import { render, staticRenderFns } from "./USPSItems.vue?vue&type=template&id=3835a130&scoped=true"
import script from "./USPSItems.vue?vue&type=script&lang=js"
export * from "./USPSItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3835a130",
  null
  
)

export default component.exports